export default __webpack_public_path__ + "static/media/nosotros.58206cde.png";